module.exports = __webpack_public_path__ + "blog-one-body.jpg?bf025f5209b6566a61433edf55f1e9bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-one-body.jpg
// module id = 122
// module chunks = 0